<template>
  <DevSitesTable :sites="devSites" :site="site" :plan="plan" />
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import DevSitesTable from "@/components/smart/tables/DevSitesTable";
import store from "@/store";

export default {
  name: "SiteDevEnvironmentsPage",
  components: {
    DevSitesTable,
  },
  props: {
    siteId: Number,
  },
  setup(props) {
    const plan = computed(() => store.getters["plans/getItem"]);
    const site = computed(() => store.getters["sites/getItem"]);
    const devSites = computed(() => ({
      list: store.getters["devSites/getList"],
      status: store.getters["devSites/getListStatus"],
    }));

    onMounted(() => {
      store.dispatch("devSites/getList", props.siteId);
    });

    return {
      plan,
      site,
      devSites,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.loader {
  height: 55vh;
}
</style>
